export const ZIPCODE_MASK = {
  ANG: {
    placeholder: '00000',
    mask: '99999',
    minlength: 5
  },
  AUS: {
    placeholder: '0000',
    mask: '9999',
    minlength: 4
  },
  EQU: {
    placeholder: '00000',
    mask: '99999',
    minlength: 5
  },
  HAI: {
    placeholder: '00000',
    mask: '99999',
    minlength: 5
  },
  PAR: {
    placeholder: '0000',
    mask: '9999',
    minlength: 4
  },
  PTG: {
    placeholder: '0000-000',
    mask: '9999-999',
    minlength: 8
  },
  VEN: {
    placeholder: '0000',
    mask: '9999',
    minlength: 4
  }
};
